import * as React from 'react';
import { connect } from 'react-redux';

const Home = () => (
    <div>
    </div>
);

export default connect()(Home);
